import { setCookie } from "Functions/cookie";
import { calculateHeaderSize } from "Functions/window";

const infoBars = document.querySelectorAll(".js-info-bar");

if (infoBars) {
    infoBars.forEach((infoBar) => {
        infoBar.querySelector(".js-info-bar-close").addEventListener("click", (event) => {
            event.preventDefault();

            const cookieKey = infoBar.dataset.cookieKey;
            const cookieValue = infoBar.dataset.cookieValue;

            setCookie(cookieKey, cookieValue, 1);

            infoBar.style.display = "none";

            requestAnimationFrame(calculateHeaderSize);
        });
    });
}
